<script setup lang="ts">
import { computed } from 'vue'

import type { PresentedOutcomeCategory } from '../../service/insightPresentation'

import type { FontAwesomeWeight, IconName } from '@/shared/ui'
import { Icon } from '@/shared/ui/icon'

// One exclusive utility pair per outcome — the same accent table the outcome badge keys on.
const OUTCOME_TONE_CLASS: Record<string, string> = {
  revenue_gain: 'bg-[var(--ui-color-insight-revenue-soft)] text-[var(--ui-color-insight-revenue)]',
  roas_uplift: 'bg-[var(--ui-color-insight-roas-soft)] text-[var(--ui-color-insight-roas)]',
  cost_savings: 'bg-[var(--ui-color-insight-savings-soft)] text-[var(--ui-color-insight-savings)]',
  lost_revenue: 'bg-[var(--ui-color-insight-risk-soft)] text-[var(--ui-color-insight-risk)]',
  planning: 'bg-[var(--ui-color-insight-planning-soft)] text-[var(--ui-color-insight-planning)]',
}
const NEUTRAL_TONE_CLASS =
  'bg-[var(--ui-color-insight-neutral-soft)] text-[var(--ui-color-insight-neutral)]'

const props = withDefaults(
  defineProps<{
    outcome: PresentedOutcomeCategory
    icon: IconName
    iconWeight: FontAwesomeWeight
    size?: number
    box?: 'md' | 'lg'
  }>(),
  { size: 18, box: 'md' },
)
const toneClass = computed(() => OUTCOME_TONE_CLASS[props.outcome] ?? NEUTRAL_TONE_CLASS)
const boxClass = computed(() => (props.box === 'lg' ? 'w-10 h-10' : 'w-8 h-8'))
</script>

<template>
  <span
    class="insight-outcome-icon grid flex-none place-items-center rounded-md"
    :class="[`insight-outcome-icon--${outcome}`, toneClass, boxClass]"
    aria-hidden="true"
  >
    <Icon :name="icon" :weight="iconWeight" :size="size" />
  </span>
</template>
